import React from 'react'

export default function ProjectsFilterLetters ({letters, value, onChange, allString}) {
  return (
    <div className={'mt-projects-archive__filter-container--letters'}>
      <ProjectsFilterLettersItem
        key={''}
        letter={allString}
        selected={value === ''}
        onClick={onChange}
      />
      {letters.map((letter) =>
        <ProjectsFilterLettersItem
          key={letter}
          letter={letter}
          selected={value === letter}
          onClick={onChange}
        />
      )}
    </div>
  )
}

function ProjectsFilterLettersItem ({letter, selected, onClick}){
  return (
    <button className={selected ? 'active' : ''} onClick={() => onClick(letter)}>
      {letter}
    </button>
  )
}
